import React from 'react'
import ContainerStaff from './ContainerStaff'
 
const Team = () => {
  
  return (
    <>


    <ContainerStaff></ContainerStaff>
    </>
  )
}

export default Team
